import { VOUCHER_TYPES } from '@/lib/consts.ts'
import __t from '@/booksy-vue-components/utils/__t.js'
import { SCREEN_NAMES } from '@/lib/analytics/consts.ts'

export const CHECKOUT_MODE = {
  CHECKOUT: 'checkout',
  EDIT_TRANSACTION: 'editTransaction',
}

export const STEPS = {
  BASKET: 'basket',
  PAYMENT_DETAILS: 'payment-details',
  PAID: 'paid',
  SPLASH: 'splash',
}

export const SCREEN_VIEWS = {
  [STEPS.BASKET]: SCREEN_NAMES.CHECKOUT_START,
  [STEPS.PAYMENT_DETAILS]: SCREEN_NAMES.CHECKOUT_OTHER_PAYMENT_METHODS,
  [STEPS.PAID]: SCREEN_NAMES.CHECKOUT_COMPLETE,
}

export const GRATUITY_TYPE = {
  BY_HAND: 'H',
  PERCENT: 'P',
}

// TRANSACTION TYPES

export const TRANSACTION_TYPES = {
  SALE: 'P',
  DEPOSIT: 'D',
}

export const TRANSACTION_TYPES_LABELS = {
  [TRANSACTION_TYPES.SALE]: __t('components.sales.cash-registers.register-operations.appointment'),
  [TRANSACTION_TYPES.DEPOSIT]: __t('components.sales.cash-registers.register-operations.cancellation-fee'),
}

export const PAYMENT_TYPE = {
  PAY_BY_APP: 'pay_by_app',
  SQUARE: 'square',
  BOOKSY_CARD_READER: 'stripe_terminal',
  PREPAYMENT: 'prepayment',
  CREDIT_CARD: 'credit_card',
  CARD: 'card', // special type for PBA
  CASH: 'cash',
  CHECK: 'check',
  CHEQUE: 'cheque',
  GIFT_CARD: 'giftcard',
  SUBSCRIPTION: 'subscription',
  PAYPAL: 'paypal',
  VOUCHER: 'voucher',
  STORE_CREDIT: 'store_credit',
  AMERICAN_EXPRESS: 'american_express',
  BANK_TRANSFER: 'bank_transfer',
  EGIFT_CARD: 'egift_card',
  MEMBERSHIP: 'membership',
  PACKAGE: 'package',
  SPLIT: 'split',
  DIRECT_PAYMENT: 'direct_payment',
  TAP_TO_PAY: 'tap_to_pay',
  BOOKSY_PAY: 'booksy_pay',
  BOOKSY_GIFT_CARD: 'booksy_gift_card',
  BLIK: 'blik',
  KEYED_IN_PAYMENT: 'keyed_in_payment',
  QUICK_CARD_ENTRY: 'quick_card_entry',
}

export const PAYMENT_TYPE_LABEL = {
  [PAYMENT_TYPE.PREPAYMENT]: __t('components.checkout.payment-type-label.prepayment'),
  [PAYMENT_TYPE.CREDIT_CARD]: __t('components.checkout.payment-type-label.credit-card'),
  [PAYMENT_TYPE.CARD]: __t('components.checkout.payment-type-label.card'),
  [PAYMENT_TYPE.CASH]: __t('components.checkout.payment-type-label.cash'),
  [PAYMENT_TYPE.CHECK]: __t('components.checkout.payment-type-label.check'),
  [PAYMENT_TYPE.GIFT_CARD]: __t('components.checkout.payment-type-label.gift-card'),
  [PAYMENT_TYPE.SUBSCRIPTION]: __t('components.checkout.payment-type-label.subscription'),
  [PAYMENT_TYPE.PAYPAL]: __t('components.checkout.payment-type-label.paypal'),
  [PAYMENT_TYPE.STORE_CREDIT]: __t('components.checkout.payment-type-label.store-credit'),
  [PAYMENT_TYPE.AMERICAN_EXPRESS]: __t('components.checkout.payment-type-label.american-express'),
  [PAYMENT_TYPE.BANK_TRANSFER]: __t('components.checkout.payment-type-label.bank-transfer'),
  [PAYMENT_TYPE.EGIFT_CARD]: __t('components.checkout.payment-type-label.egift-card'),
  [PAYMENT_TYPE.MEMBERSHIP]: __t('components.checkout.payment-type-label.membership'),
  [PAYMENT_TYPE.PACKAGE]: __t('components.checkout.payment-type-label.package'),
  [PAYMENT_TYPE.SPLIT]: __t('components.checkout.payment-type-label.split'),
  [PAYMENT_TYPE.BOOKSY_PAY]: __t('components.checkout.payment-type-label.booksy_pay'),
  [PAYMENT_TYPE.BOOKSY_GIFT_CARD]: __t('components.checkout.payment-type-label.booksy-gift-card'),
}

export const VOUCHER_TYPES_FROM_PAYMENT_TYPE = {
  [PAYMENT_TYPE.EGIFT_CARD]: VOUCHER_TYPES.GIFT_CARD,
  [PAYMENT_TYPE.MEMBERSHIP]: VOUCHER_TYPES.MEMBERSHIP,
  [PAYMENT_TYPE.PACKAGE]: VOUCHER_TYPES.PACKAGE,
}

export const PAYMENT_TYPE_FROM_VOUCHER_TYPES = {
  [VOUCHER_TYPES.GIFT_CARD]: PAYMENT_TYPE.EGIFT_CARD,
  [VOUCHER_TYPES.MEMBERSHIP]: PAYMENT_TYPE.MEMBERSHIP,
  [VOUCHER_TYPES.PACKAGE]: PAYMENT_TYPE.PACKAGE,
}

export const PAYMENT_TYPE_ICON_SVG = {
  [PAYMENT_TYPE.AMERICAN_EXPRESS]: {
    name: 'american-express',
    size: '56px',
  },
  [PAYMENT_TYPE.PAYPAL]: {
    name: 'paypal',
    size: '20px',
  },
  [PAYMENT_TYPE.BOOKSY_CARD_READER]: {
    name: 'bcr',
    size: '32px',
  },
  [PAYMENT_TYPE.QUICK_CARD_ENTRY]: {
    name: 'quick-card-entry',
    size: '32px',
  },
  [PAYMENT_TYPE.CREDIT_CARD]: {
    name: 'card',
    size: '32px',
  },
  [PAYMENT_TYPE.CASH]: {
    name: 'cash',
    size: '32px',
  },
  [PAYMENT_TYPE.GIFT_CARD]: {
    name: 'giftcard',
    size: '32px',
  },
  [PAYMENT_TYPE.EGIFT_CARD]: {
    name: 'giftcard',
    size: '32px',
  },
  [PAYMENT_TYPE.MEMBERSHIP]: {
    name: 'membership',
    size: '32px',
  },
  [PAYMENT_TYPE.PACKAGE]: {
    name: 'package',
    size: '32px',
  },
  [PAYMENT_TYPE.VOUCHER]: {
    name: 'membership',
    size: '32px',
  },
  [PAYMENT_TYPE.SUBSCRIPTION]: {
    name: 'membership',
    size: '32px',
  },
  [PAYMENT_TYPE.SPLIT]: {
    name: 'split-payment',
    size: '32px',
  },
  [PAYMENT_TYPE.PAY_BY_APP]: {
    name: 'mobile-payment',
    size: '32px',
  },
  [PAYMENT_TYPE.CHECK]: {
    name: 'check',
    size: '32px',
  },
  [PAYMENT_TYPE.SQUARE]: {
    name: 'ico_square',
    size: '32px',
  },
  [PAYMENT_TYPE.BLIK]: {
    name: 'blik',
    size: '38px',
  },
  [PAYMENT_TYPE.KEYED_IN_PAYMENT]: {
    name: 'keyed-in-payment',
    size: '32px',
  },
}

export const PAYMENT_ROW_MODE = {
  COMPLETE: 'C',
  KEEP: 'K',
}

export const SUMMARIES_TYPE = {
  SUBTOTAL: 'subtotal',
  TAXES: 'taxes',
  DISCOUNT: 'discount',
  PLATFORM_FEE: 'platform_fee',
}

export const RECEIPT_STATUS_TYPE = {
  PARTIAL_SETTLEMENT: 'partial_settlement',
  PARK_SALE: 'park_sale',
  PREPAYMENT: 'prepayment',
  SUCCESS: 'success',
  FAILED: 'failed',
  CANCELED: 'canceled',
  CALL_FOR_PAYMENT: 'call_for_payment',
  CALL_FOR_DEPOSIT: 'call_for_deposit',
  PENDING: 'pending',
  ARCHIVED: 'archived',
  AUTHORIZED: 'authorized',
  BOOKSY_PAY: 'booksy_pay',
  BOOKSY_GIFT_CARD: 'booksy_gift_card',
}

export const TRANSACTION_STATUSES = [
  RECEIPT_STATUS_TYPE.PARTIAL_SETTLEMENT,
  RECEIPT_STATUS_TYPE.PARK_SALE,
  RECEIPT_STATUS_TYPE.PREPAYMENT,
  RECEIPT_STATUS_TYPE.CANCELED,
  RECEIPT_STATUS_TYPE.FAILED,
  RECEIPT_STATUS_TYPE.BOOKSY_PAY,
  RECEIPT_STATUS_TYPE.BOOKSY_GIFT_CARD,
]

export const SEARCH_OBJECT_TYPES = {
  SERVICE_VARIANT: 'service-variant',
  PRODUCT: 'product',
  ADDONS: 'addon',
}

export const BASKET_MENU = {
  TURNS: 'turns',
  QUICK_SALE: 'quick-sale',
  APPOINTMENTS: 'appointments',
  SERVICES: 'services',
  ADDONS: 'addons',
  PRODUCTS: 'products',
  CUSTOM_AMOUNT: 'custom-amount',
}

export const BASKET_APPOINTMENTS_MODE = {
  TURNS: 'turns',
  APPOINTMENTS: 'appointments',
}

export const DEV_BASKET_MENU = {
  GIFT_CARDS: 'gift-cards',
  PACKAGES: 'packages',
  MEMBERSHIPS: 'memberships',
}

export const RESOLVE_ACTION = {
  CHARGE_CARD_ON_FILE: 'charge-card-on-file',
  CHARGE_BOOKSY_GIFT_CARD: 'charge-booksy-gift-card',
}

export const BCR_STRIPE_ACTIONS = {
  CAPTURE: 'capture',
  CANCEL: 'cancel',
  FAILED: 'fail',
}

export const ROW_TYPES = {
  ADDONS: 'A',
  DEPOSIT: 'D',
  PRODUCT: 'P',
  SERVICE: 'S',
  TRAVEL_FEE: 'T',
}

export const CHECKOUT_SOURCE = {
  CALENDAR: 'calendar',
  TURN_TRACKER: 'turn-tracker',
}

export const DONT_ASK_AGAIN_ASSIGN_SALE_KEY = 'checkout.dontAskAgainAboutAssignSale'

export const PLATFORM_FEE_MODES = {
  CX_FULL_COST: 'cx_full_cost',
  SPLIT: 'split',
  PX_FULL_COST: 'px_full_cost',
}

// POS2
export const BASKET_TYPE = {
  PAYMENT: 'payment',
  DEPOSIT: 'deposit',
}

export const BASKET_STATUS = {
  PENDING: 'pending',
  ACTION_REQUIRED: 'action_required',
  SUCCESS: 'success',
  FAILED: 'failed',
  CANCELED: 'canceled',
  SENT_FOR_REFUND: 'sent_for_refund',
  REFUNDED: 'refunded',
  CHARGEBACK: 'chargeback',
  CHARGEBACK_REVERSED: 'chargeback_reversed',
  SECOND_CHARGEBACK: 'second_chargeback',
}

export const BASKET_STATUS_LABEL = {
  [BASKET_STATUS.PENDING]: __t('components.payments.basket-status.pending'),
  [BASKET_STATUS.ACTION_REQUIRED]: __t('components.payments.basket-status.action-required'),
  [BASKET_STATUS.SUCCESS]: __t('components.payments.basket-status.success'),
  [BASKET_STATUS.FAILED]: __t('components.payments.basket-status.failed'),
  [BASKET_STATUS.CANCELED]: __t('components.payments.basket-status.canceled'),
  [BASKET_STATUS.SENT_FOR_REFUND]: __t('components.payments.basket-status.sent-for-refund'),
  [BASKET_STATUS.REFUNDED]: __t('components.payments.basket-status.refunded'),
  [BASKET_STATUS.CHARGEBACK]: __t('components.payments.basket-status.chargeback'),
  [BASKET_STATUS.CHARGEBACK_REVERSED]: __t('components.payments.basket-status.chargeback-reversed'),
  [BASKET_STATUS.SECOND_CHARGEBACK]: __t('components.payments.basket-status.second-chargeback'),
}

export const BADGE_COLOR_FROM_BASKET_STATUS = {
  [BASKET_STATUS.PENDING]: 'orange',
  [BASKET_STATUS.ACTION_REQUIRED]: 'orange',
  [BASKET_STATUS.SUCCESS]: 'green',
  [BASKET_STATUS.FAILED]: 'red',
  [BASKET_STATUS.CANCELED]: 'gray',
  [BASKET_STATUS.SENT_FOR_REFUND]: 'orange',
  [BASKET_STATUS.REFUNDED]: 'gray',
  [BASKET_STATUS.CHARGEBACK]: 'red',
  [BASKET_STATUS.CHARGEBACK_REVERSED]: 'green',
  [BASKET_STATUS.SECOND_CHARGEBACK]: 'red',
}

export const BASKET_PAYMENT_STATUS = {
  PENDING: 'pending',
  ACTION_REQUIRED: 'action_required',
  SUCCESS: 'success',
  FAILED: 'failed',
  CANCELED: 'canceled',
}

export const BASKET_PAYMENT_STATUS_LABEL = {
  [BASKET_PAYMENT_STATUS.PENDING]: __t('components.payments.basket-payment-status.pending'),
  [BASKET_PAYMENT_STATUS.ACTION_REQUIRED]: __t('components.payments.basket-payment-status.action-required'),
  [BASKET_PAYMENT_STATUS.SUCCESS]: __t('components.payments.basket-payment-status.success'),
  [BASKET_PAYMENT_STATUS.FAILED]: __t('components.payments.basket-payment-status.failed'),
  [BASKET_PAYMENT_STATUS.CANCELED]: __t('components.payments.basket-payment-status.canceled'),
}

export const BASKET_PAYMENT_TYPE_CODE = {
  // Online
  BOOKSY_CARD_READER: 'terminal',
  CARD: 'card', // special type for PBA
  SQUARE: 'square',
  GOOGLE_PAY: 'google_pay',
  APPLE_PAY: 'apple_pay',
  TAP_TO_PAY: 'tap_to_pay',
  BLIK: 'blik',
  KEYED_IN_PAYMENT: 'keyed_in_payment',
  KLARNA: 'klarna',

  // Offline
  CASH: 'cash',
  CHECK: 'check',
  CREDIT_CARD: 'credit_card',
  SUBSCRIPTION: 'subscription',
  STORE_CREDIT: 'store_credit',
  BANK_TRANSFER: 'bank_transfer',
  AMERICAN_EXPRESS: 'american_express',
  PAYPAL: 'paypal',
  BOOKSY_GIFT_CARD: 'booksy_gift_card',
  EGIFT_CARD: 'egift_card',
  MEMBERSHIP: 'membership',
  PACKAGE: 'package',
  DIRECT_PAYMENT: 'direct_payment',

  PAY_BY_APP_DONATIONS: 'pba_donations', // deprecated
  // These two paymentTypes are deprecated. Still here, because of displaying
  GIFT_CARD: 'giftcard',
  VOUCHER: 'voucher',
}

export const BASKET_PAYMENT_TYPE = {
  PAYMENT: 'payment',
  REFUND: 'refund',
  CHARGEBACK: 'dispute',
  CHARGEBACK_REVERSED: 'chargeback_reversed',
  SECOND_CHARGEBACK: 'second_chargeback',
}

export const BASKET_PAYMENT_TYPE_LABEL = {
  [BASKET_PAYMENT_TYPE.PAYMENT]: __t('components.payments.basket-payment-type.payment'),
  [BASKET_PAYMENT_TYPE.REFUND]: __t('components.payments.basket-payment-type.refund'),
  [BASKET_PAYMENT_TYPE.CHARGEBACK]: __t('components.payments.basket-payment-type.chargeback'),
  [BASKET_PAYMENT_TYPE.CHARGEBACK_REVERSED]: __t('components.payments.basket-payment-type.chargeback-reversed'),
  [BASKET_PAYMENT_TYPE.SECOND_CHARGEBACK]: __t('components.payments.basket-payment-type.second-chargeback'),
}

export const BASKET_PAYMENT_TYPE_SOURCE = {
  PREPAYMENT: 'prepayment',
  CANCELLATION_FEE: 'cancellation_fee',
  PAYMENT: 'payment',
  BOOKSY_PAY: 'booksy_pay',
}
